import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdateRuleEngineModal, BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { VerticalDotsSvg } from "../../assets/svgs";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { getRuleEngineManagementInboxData, postAddedRulesReview, postUpdatedRulesReview } from "../../redux/slices/rule-engine-management-inbox-slice";
import { Menus } from "../../constants/menus-constant";
import ReactTable from "react-table";
import { useLocation } from "react-router";
import { getCountryList } from "../../redux/slices/rule-engine-slice";
import { getInstitutionsList } from "../../redux/slices/institutions-list-slice";

const RuleEngineManagementInbox = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, inboxData, pagination } = useSelector((state) => state.ruleEngineManagementInboxReducer);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const isChecker = location.pathname.includes('checker');
    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: true,
        isView: false,
    };

    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState();

    const defaultParams = { pagination: states.pagination };

    const getInboxData = async (updatedParams) => {
        if (user && updatedParams) {
            dispatch(getRuleEngineManagementInboxData({ user, ...updatedParams }));
            dispatch(getInstitutionsList(user));
        }
    };

    // const handleReload = () => {
    //     getInboxData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getInboxData(params);
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleModalOpen = () => {
        const taskDetailRes = states?.selected?.taskDetailRes || {};
        setForm({
            institution: Number(taskDetailRes?.institutionId),
            institutionRuleStatus: taskDetailRes?.institutionRuleStatus || false,
            configurations: taskDetailRes?.institutionBinRanges?.map((binRange, index) => {
                // Extract arrays directly from rulesConfiguration
                const numberOfSuccessfullTransaction = binRange?.rulesConfiguration?.numberOfSuccessfullTransaction || [];
                const numberOfDays = binRange?.rulesConfiguration?.numberOfDays || [];
                const purchaseAmount = binRange?.rulesConfiguration?.purchaseAmount || [];
                const ruleScoreMatrix = binRange?.ruleScoreMatrix || {};

                // Helper function to get value by risk level
                const getValueByRisk = (array, risk) => array?.find(item => item.risk === risk);

                // Extract weightage object safely
                const rulesWeitage = binRange?.rulesWeitage || {};

                return {
                    id: index + 1,
                    scheme: [],
                    bins: [{
                        label: binRange?.bin,
                        value: binRange?.binRangeId,
                        scheme: {
                            label: binRange?.schemeId?.name,
                            value: binRange?.schemeId?.id,
                            logo: binRange?.schemeId?.logoDataUri
                        }
                    }],
                    // Number of Successful Transactions - try array first, fallback to individual fields
                    numberOfSuccessfullTransactionLow: getValueByRisk(numberOfSuccessfullTransaction, "LOW")?.value || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionLow || "",
                    numberOfSuccessfullTransactionMedium: getValueByRisk(numberOfSuccessfullTransaction, "MEDIUM")?.value || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionMedium || "",
                    numberOfSuccessfullTransactionHigh: getValueByRisk(numberOfSuccessfullTransaction, "HIGH")?.value || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionHigh || "",
                    numberOfSuccessfullTransactionLowScore: getValueByRisk(numberOfSuccessfullTransaction, "LOW")?.score || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionLowScore || 0,
                    numberOfSuccessfullTransactionMediumScore: getValueByRisk(numberOfSuccessfullTransaction, "MEDIUM")?.score || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionMediumScore || 0,
                    numberOfSuccessfullTransactionHighScore: getValueByRisk(numberOfSuccessfullTransaction, "HIGH")?.score || binRange?.rulesConfiguration?.numberOfSuccessfullTransactionHighScore || 0,
                    // Number of Days - try array first, fallback to individual fields
                    numberOfDaysLow: getValueByRisk(numberOfDays, "LOW")?.value || binRange?.rulesConfiguration?.numberOfDaysLow || "",
                    numberOfDaysMedium: getValueByRisk(numberOfDays, "MEDIUM")?.value || binRange?.rulesConfiguration?.numberOfDaysMedium || "",
                    numberOfDaysHigh: getValueByRisk(numberOfDays, "HIGH")?.value || binRange?.rulesConfiguration?.numberOfDaysHigh || "",
                    // Purchase Amount - try array first, fallback to individual fields
                    purchaseAmountLow: getValueByRisk(purchaseAmount, "LOW")?.value || binRange?.rulesConfiguration?.purchaseAmountLow || "",
                    purchaseAmountMedium: getValueByRisk(purchaseAmount, "MEDIUM")?.value || binRange?.rulesConfiguration?.purchaseAmountMedium || "",
                    purchaseAmountHigh: getValueByRisk(purchaseAmount, "HIGH")?.value || binRange?.rulesConfiguration?.purchaseAmountHigh || "",
                    purchaseAmountLowScore: getValueByRisk(purchaseAmount, "LOW")?.score || binRange?.rulesConfiguration?.purchaseAmountLowScore || 0,
                    purchaseAmountMediumScore: getValueByRisk(purchaseAmount, "MEDIUM")?.score || binRange?.rulesConfiguration?.purchaseAmountMediumScore || 0,
                    purchaseAmountHighScore: getValueByRisk(purchaseAmount, "HIGH")?.score || binRange?.rulesConfiguration?.purchaseAmountHighScore || 0,
                    // ---- NEW: Rule weightages ----
                    currencyCodeWeitage: rulesWeitage?.currencyCodeWeitage || "",
                    deviceFingerPrintWeitage: rulesWeitage?.deviceFingerPrintWeitage || "",
                    numberOfSuccessfullTransactionWeitage: rulesWeitage?.numberOfSuccessfullTransactionWeitage || "",
                    purchaseAmountWeitage: rulesWeitage?.purchaseAmountWeitage || "",
                    // Direct values
                    deviceFingerPrintScore: binRange?.rulesConfiguration?.deviceFingerPrintScore || 0,
                    currencies: binRange?.rulesConfiguration?.currencies || [],
                    currencyCodeScore: binRange?.rulesConfiguration?.currencyCodeScore || 0,
                    effectiveDateTime: binRange?.rulesConfiguration?.effectiveDateTime || "",
                    // Summary values for table display
                    numberOfDays: numberOfDays,
                    frictionlessScoreThreshold: ruleScoreMatrix?.frictionlessScoreThreshold || "",
                    numberOfSuccessfullTransaction: numberOfSuccessfullTransaction,
                    purchaseAmount: purchaseAmount,
                    rulesOperator: binRange?.rulesOperator || {},
                    isConfigured: 2,
                };
            }),
            reason: states?.selected?.reason
        });

        if (states?.selected?.operation?.toLowerCase()?.includes('activation')) {
            setStates((old) => ({ ...old, isModalOpen: true, isView: true, isUpdate: false }));
        } else {
            setStates((old) => ({ ...old, isModalOpen: true, isView: false, isUpdate: true }));
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null }));
    };

    const handleFormSubmit = (payloads) => {
        const { operation, processId } = states.selected;
        const { ruleEngineRules, ...payload } = payloads;

        const currentOperation = operation?.toLowerCase();
        const isUpdateOperation = ['rule deactivation', 'rule activation', 'rule updation'].includes(currentOperation);

        const updatedData = {
            ...payload,
            operation,
            processId,
            ...(isUpdateOperation
                ? { ruleEngineRules: ruleEngineRules }
                : { ruleEngineRules: ruleEngineRules })
        };

        const actionCreator = isUpdateOperation
            ? postUpdatedRulesReview
            : postAddedRulesReview;

        dispatch(actionCreator({ user, body: updatedData })).then((action) => {
            if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                handleModalClose();
                getInboxData(defaultParams);
            }
        });
    };

    const actions = [
        { label: isChecker ? 'Review' : 'Edit', action: () => handleModalOpen() },
    ];

    useEffect(() => {
        getInboxData(defaultParams);
        dispatch(getCountryList(user));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (inboxData && Array.isArray(inboxData)) {
            setStates((old) => ({ ...old, data: inboxData, pagination: pagination }));
        }
    }, [inboxData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'processId', headerName: 'Process ID', width: 150 },
    //     {
    //         field: 'desc', headerName: 'Institution', width: 130,
    //         valueGetter: (row) => row?.taskDetailRes?.desc
    //     },
    //     {
    //         field: 'institutionBinRanges',
    //         headerName: 'Configured Bins',
    //         sortable: false,
    //         width: 150,
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.taskDetailRes?.institutionBinRanges && row?.taskDetailRes?.institutionBinRanges?.length > 0 && (
    //                             <>
    //                                 {row?.taskDetailRes?.institutionBinRanges.slice(0, 3).map(bin => bin?.bin).join(', ')}
    //                                 {row?.taskDetailRes?.institutionBinRanges.length > 3 &&
    //                                     `, +${row?.taskDetailRes?.institutionBinRanges.length - 3}`
    //                                 }
    //                             </>
    //                         )
    //                     }
    //                 </>
    //             )
    //         },
    //     },
    //     {
    //         field: 'operation',
    //         headerName: 'Operation',
    //         width: 170,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             const operation = row?.operation?.toLowerCase();
    //             let badgeType = 'default';

    //             if (operation?.includes('deactivation')) {
    //                 badgeType = 'error';
    //             } else if (operation?.includes('activation')) {
    //                 badgeType = 'success';
    //             } else if (operation?.includes('updation')) {
    //                 badgeType = 'warning';
    //             }

    //             return (
    //                 <>
    //                     {
    //                         row?.operation &&
    //                         <BadgeComponent label={row?.operation} outline type={badgeType} />
    //                     }
    //                 </>
    //             );
    //         },
    //         sortBy: (row) => row?.operation,
    //     },
    //     { field: 'createdBy', headerName: 'Created / Modified By', width: 160 },
    //     {
    //         field: 'isaccepted',
    //         headerName: 'Status',
    //         width: 120,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         ([true, false].includes(row?.isaccepted) && row?.reason) ? (
    //                             <BadgeComponent label={row?.isaccepted ? 'Accepted' : 'Rejected'} type={row?.isaccepted ? 'success' : 'error'} />
    //                         ) : (
    //                             <BadgeComponent label='Pending' type='default' />
    //                         )
    //                     }
    //                 </>
    //             )
    //         },
    //         // sortBy: (row) => row.userStatus.label,
    //     },
    //     { field: 'reason', headerName: 'Comments', width: 140 },
    //     { field: 'reqInitDateTime', headerName: 'Request Date', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'reqInitDateTime', Header: 'Request Date', minWidth: 180,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false,
        },
        {
            accessor: 'processId', Header: 'Process ID', minWidth: 180,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'desc',
            Header: 'Institution',
            minWidth: 140,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.taskDetailRes?.desc,
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'institutionBinRanges',
            Header: 'Configured Bins',
            style: { textAlign: 'center' },
            minWidth: 140,
            sortable: false,
            filterable: false,
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.taskDetailRes?.institutionBinRanges && row?.original?.taskDetailRes?.institutionBinRanges?.length > 0 && (
                                <>
                                    {row?.original?.taskDetailRes?.institutionBinRanges.slice(0, 3).map(bin => bin?.bin).join(', ')}
                                    {row?.original?.taskDetailRes?.institutionBinRanges.length > 3 &&
                                        `, +${row?.original?.taskDetailRes?.institutionBinRanges.length - 3}`
                                    }
                                </>
                            )
                        }
                    </>
                )
            },
        },
        {
            accessor: 'operation',
            Header: 'Operation',
            minWidth: 180,
            style: { textAlign: 'center' },
            sortable: false,
            filterable: false,
            Cell: (row) => {
                const operation = row?.original?.operation?.toLowerCase();
                let badgeType = 'default';

                if (operation?.includes('deactivation')) {
                    badgeType = 'error';
                } else if (operation?.includes('activation')) {
                    badgeType = 'success';
                } else if (operation?.includes('updation')) {
                    badgeType = 'warning';
                }

                return (
                    <>
                        {
                            row?.original?.operation &&
                            <BadgeComponent label={row?.original?.operation} type={badgeType} />
                        }
                    </>
                );
            },
        },
        {
            accessor: 'createdBy', Header: 'Created / Modified By', minWidth: 140,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'isaccepted',
            Header: 'Status',
            minWidth: 140,
            style: { textAlign: 'center' },
            Cell: (row) => {
                return (
                    <>
                        {
                            ([true, false].includes(row?.original?.isaccepted) && row?.original?.reason) ? (
                                <BadgeComponent label={row?.original?.isaccepted ? 'Accepted' : 'Rejected'} type={row?.original?.isaccepted ? 'success' : 'error'} />
                            ) : (
                                <BadgeComponent label='Pending' type='warning' />
                            )
                        }
                    </>
                )
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'reason', Header: 'Comments', minWidth: 120,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Inbox</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel },
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/*
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            */}

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={false}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateRuleEngineModal data={form} label={states?.selected?.operation} viewOnly={states.isView} update={states.isUpdate} close={handleModalClose} handleFormSubmit={handleFormSubmit} fromMakerChecker slide />
            }
        </AuthPageContainer>
    );
};

export default RuleEngineManagementInbox;